import { render, staticRenderFns } from "./pmsForm.vue?vue&type=template&id=3213304b"
import script from "./pmsForm.vue?vue&type=script&lang=js"
export * from "./pmsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports